import React, { useRef } from 'react'
import './Contact.css'
import {HiOutlineMail} from 'react-icons/hi'
import {BsMessenger} from 'react-icons/bs'
import {BsWhatsapp} from 'react-icons/bs'
import emailjs from 'emailjs-com'

const Contact = () => {
  const form =useRef();
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', form.current, 'YOUR_PUBLIC_KEY')
    e.target.reset();
  };
  return (
  <section id='contact'> 
  <h5>Get in Touch</h5>
  <h2>Contact ME</h2>

  <div className='container contact_container'>
    <div className='contact_options'>
      <article className='contact_option'>
        <HiOutlineMail className='contact_option-icon'/>
        <h4>Email</h4>
        <h4>gurpreetlambton21@gmail.com</h4>
        <a href='mailto:guri@gmail.com' target="_blank" without rel="noreferrer">Send a Message</a>
      </article>

      <article className='contact_option'>
        <BsMessenger className='contact_option-icon'/>

        <h4>Messenger</h4>
        <h5>tutorials</h5>
        <a href='mailto:guri@gmail.com' target="_blank" without rel="noreferrer">Send a Message</a>
      </article>

      <article className='contact_option'>
      <BsWhatsapp className='contact_otpion-icon'/>
        <h4>WhatsApp</h4>
        <h5>+1 226-402-0355</h5>
        <a href='https://api.whatsapp.com/send?phone+122654654'without rel="noreferrer"  target="_blank">Send a Message</a>
      </article>
    </div>

    {/* end of contact options*/}
    <form ref={form} onSubmit={sendEmail}>
      <input type="text" name ="name" placeholder='your full name' required/>
      <input type="email" name ="email" placeholder='your email' required/>
      <textarea name='message' rows="7" placeholder='Your message ' required></textarea>
      <button type='submit' className='btn btn-primary'> Send Message</button>
    </form>
  </div>
  
  </section>
  )
}

export default Contact